import React, { type ComponentProps, type ReactNode } from 'react';
import { Surface } from '@storebrand-digital/pretzel';
import styles from './LayoutContainer.module.css';

export function Main({
  children,
  className,
  ...props
}: ComponentProps<typeof Surface>) {
  return (
    <Surface
      {...props}
      className={[styles.main, className].filter(Boolean).join(' ')}
    >
      {children}
    </Surface>
  );
}

export function LayoutContainer({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { children?: ReactNode }) {
  return (
    <div
      {...props}
      className={[styles.layoutContainer, className].filter(Boolean).join(' ')}
    >
      {children}
    </div>
  );
}
